import { AuthResource, authResource } from '@/resources/auth.resource';
import router from '@/router';
import { buildMenu, getMenuElements } from '@/utils/menu';
import { AbstractModule } from './abstract.module';

export class MenuModule extends AbstractModule<AuthResource> {
  public state = {
    menu: {}
  };

  public mutations = {
    saveMenu(localState: any, menu: any): void {
      localState.menu = menu;
    }
  };

  public actions = {
    getMenu(context: any, query?: string): Promise<void> {
      const routes = getMenuElements((router as any).options.routes);
      if (!routes) {
        return Promise.resolve();
      }
      return buildMenu(routes, query).then(menu => context.commit('saveMenu', menu));
    }
  };
}

export default new MenuModule(authResource);
